import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { StorageMap } from "@ngx-pwa/local-storage";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { PaymentRequestService } from "src/app/core/services/payment-request.service";
import { EGiftTransaction } from "src/app/shared/models/eGift/EGiftTransaction.model";

@Component({
	selector: "app-gift-wallet-create-pass",
	templateUrl: "./gift-wallet-create-pass.component.html",
	styleUrls: ["../gift.style.scss"],
})
export class GiftWalletCreatePassComponent implements OnInit {
	message: string;
	transaction: EGiftTransaction;
	transactionGuid: string;
	venueKey: number;

	constructor(
		private focuslink: FocuslinkService,
		private route: ActivatedRoute,
		private router: Router,
		private storage: StorageMap,
		public app: AppService,
		public paymentReqSvc: PaymentRequestService,
		private titleService: Title
	) {}

	ngOnInit(): void {
		this.message = "Fetching transaction...";
		this.app.loading(true);
		this.venueKey = +this.route.snapshot.paramMap.get("venueKey");
		this.transactionGuid = this.route.snapshot.paramMap.get("transactionGuid");
		this.titleService.setTitle("Focus POS Gift Cards");
		this.init();
	}

	async init() {
		await this.getTransaction(this.transactionGuid);
		if (this.transaction.activated) {
			this.message = "Fetching your Apple Wallet Gift Card...";
			await this.createPass(this.transaction.key);
		} else {
			this.message = "This gift card has not been activated yet.";
		}
	}

	async getTransaction(transactionGuid: string) {
		const resp = await this.focuslink.eGiftTransactionGetOne(this.venueKey, transactionGuid);
		this.transaction = new EGiftTransaction(resp);
	}

	async createPass(transactionGuid: string) {
		const obj = await this.focuslink.appleWalletGiftPass(this.venueKey, this.transactionGuid);
		this.app.loading(false);
		window.location.href = obj.s3Url;
	}
}
